export enum HearAboutSourceKey {
  GOOGLE_SEARCH = 'google_search',
  AI_ASSISTANT = 'ai_assistant',
  FRIEND_OR_COLLEAGUE = 'friend_or_colleague',
  ACCOUNTANT = 'accountant',
  LINKEDIN = 'linkedin',
  SOCIAL = 'social',
  AD = 'ad',
  MEDIA = 'media',
  OTHER = 'other'
}

export const HEAR_ABOUT_SOURCE_ORDER: HearAboutSourceKey[] = [
  HearAboutSourceKey.GOOGLE_SEARCH,
  HearAboutSourceKey.AI_ASSISTANT,
  HearAboutSourceKey.FRIEND_OR_COLLEAGUE,
  HearAboutSourceKey.ACCOUNTANT,
  HearAboutSourceKey.LINKEDIN,
  HearAboutSourceKey.SOCIAL,
  HearAboutSourceKey.AD,
  HearAboutSourceKey.MEDIA,
  HearAboutSourceKey.OTHER
]

export const hearAboutSelectionNeedsText = (sources: HearAboutSourceKey[]): boolean =>
  sources.includes(HearAboutSourceKey.OTHER)

const DETAIL_PLACEHOLDER_PRIORITY = [
  HearAboutSourceKey.OTHER,
  HearAboutSourceKey.FRIEND_OR_COLLEAGUE,
  HearAboutSourceKey.ACCOUNTANT,
  HearAboutSourceKey.AD
] as const

type HearAboutDetailPlaceholderKey = (typeof DETAIL_PLACEHOLDER_PRIORITY)[number] | 'default'

export const getHearAboutDetailPlaceholderKey = (
  sources: HearAboutSourceKey[]
): HearAboutDetailPlaceholderKey => {
  for (const source of DETAIL_PLACEHOLDER_PRIORITY) {
    if (sources.includes(source)) {
      return source
    }
  }
  return 'default'
}

const shuffle = <T>(items: T[]): T[] => {
  const copy = [...items]
  for (let index = copy.length - 1; index > 0; index -= 1) {
    const swapIndex = Math.floor(Math.random() * (index + 1))
    ;[copy[index], copy[swapIndex]] = [copy[swapIndex], copy[index]]
  }
  return copy
}

export const getShuffledHearAboutSources = (): HearAboutSourceKey[] => {
  const withoutOther = HEAR_ABOUT_SOURCE_ORDER.filter(source => source !== HearAboutSourceKey.OTHER)
  return [...shuffle(withoutOther), HearAboutSourceKey.OTHER]
}
